var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecents({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.4669C5.58333 15.4669 3.91319 14.8117 2.48958 13.5013C1.06597 12.1909 0.25 10.5547 0.0416667 8.59271H1.75C1.94444 10.0821 2.58681 11.3137 3.67708 12.2876C4.76736 13.2614 6.04167 13.7483 7.5 13.7483C9.125 13.7483 10.5035 13.1648 11.6354 11.9976C12.7674 10.8304 13.3333 9.40902 13.3333 7.73344C13.3333 6.05786 12.7674 4.63648 11.6354 3.46931C10.5035 2.30213 9.125 1.71854 7.5 1.71854C6.54167 1.71854 5.64583 1.94768 4.8125 2.40596C3.97917 2.86424 3.27778 3.49437 2.70833 4.29636H5V6.0149H0V0.859271H1.66667V2.87856C2.375 1.962 3.23958 1.2531 4.26042 0.751862C5.28125 0.250621 6.36111 0 7.5 0C8.54167 0 9.51736 0.204077 10.4271 0.612231C11.3368 1.02038 12.1285 1.57175 12.8021 2.26633C13.4757 2.96091 14.0104 3.77721 14.4062 4.71525C14.8021 5.65329 15 6.65935 15 7.73344C15 8.80753 14.8021 9.81359 14.4062 10.7516C14.0104 11.6897 13.4757 12.506 12.8021 13.2006C12.1285 13.8951 11.3368 14.4465 10.4271 14.8547C9.51736 15.2628 8.54167 15.4669 7.5 15.4669ZM9.83333 11.3424L6.66667 8.07715V3.43708H8.33333V7.38973L11 10.1394L9.83333 11.3424Z",
    fill: "#0A8BC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecents);
export default __webpack_public_path__ + "static/media/recents.cba36f580c57bf62f953ed3ae902871c.svg";
export { ForwardRef as ReactComponent };